import HideShowFavWrapper from "@components/favoritePlayers/hideShowFavWrapper";
import RemoveRowAndUpdateLocalStorage from "@components/favoritePlayers/removeRowAndUpdateLocalStorage";
import RowTemplate from "@components/favoritePlayers/rowTemplate";
import RoundsColumn from "@components/favoritePlayers/roundsColumn";
import SetActiveRow from "@components/favoritePlayers/setActiveRow";
import RemoveRowFromFavorite from "@components/favoritePlayers/removeRowFromFavorite";
import ColorAndPar from "@components/favoritePlayers/colorAndPar";

// --------------------------------------------------

import {
  countRowInTable,
  select,
  checkApID,
  getItemLocalStorage,
  setItemLocalStorage,
  convertJSONToArray,
  GetColorFromCourse,
} from "@utils/function";

import UpdatePlayersScoring from "@components/map/playerScoring";
import AnalyticsTracking from "@helpers/analyticsTracking";

// --------------------------------------------------
// add app id to local storage

checkApID();

// --------------------------------------------------

const storageName = "HQfavoritePlayers";

const tablePlayers = select(".table-players");
const tableFavorites = select(".table-favorites > tbody");
const favWrapper = select(".fav-wrapper");

const currentRoundExist =
  typeof HQ.Properties.currentRound !== "undefined" ? true : false;

let selectedPlayers = [];
let updatePlayers = [];

window.addEventListener("updatePlayers", (e) => {
  updatePlayers = e.detail.updatePlayers;
  HQ.Properties.getAllPlayers = e.detail.getAllPlayers;

  // generate favorite table
  CreateTabelRowFromLocalStorage();

  const HQshowScoringPlayer = getItemLocalStorage("HQshowScoringPlayer");
  const HQshowFavoritesPlayer = getItemLocalStorage("HQshowFavoritesPlayer");
  if (
    (HQshowScoringPlayer && HQshowScoringPlayer?.length > 0) ||
    (HQshowFavoritesPlayer && HQshowFavoritesPlayer?.length > 0)
  ) {
    UpdatePlayersScoring();
  }
});

// ------------------------------------------------------------
// chheck if exist players in local storage

function GetPlayersFromLocalStorage() {
  const players = getItemLocalStorage(storageName);

  if (!players) return;

  // create table row in favorites table
  // when localstorage is not empty
  CreateTabelRowFromLocalStorage();
}

GetPlayersFromLocalStorage();

UpdatePlayersScoring();

// ------------------------------------------------------------
// click on players

tablePlayers.addEventListener("click", (e) => {
  e.preventDefault();
  const target = e.target;

  if (
    target.classList.contains("icon-star") &&
    !target.closest("tr").classList.contains("active-row")
  ) {
    const row = target.closest("tr");

    if (!row.classList.contains("active-row")) {
      row.closest("tr").classList.add("active-row");
      // console.log("aaaaaaaaaaaa", row.dataset.id);
      SetRowToFavorite(row.dataset.id);

      // add analytics when press icon-star favorite
      AnalyticsTracking("setFavorite", { name: row.dataset.fullName });
    } else {
      row.closest("tr").classList.remove("active-row");
      RemoveRowFromFavorite(
        tableFavorites,
        row.dataset.id,
        selectedPlayers,
        storageName
      );
    }

    HideShowFavWrapper(favWrapper, countRowInTable(tableFavorites));

    UpdatePlayersScoring();
  } else if (target.classList.contains("icon-star")) {
    const row = target.closest("tr");

    row.classList.remove("active-row");
    RemoveRowFromFavorite(
      tableFavorites,
      row.dataset.id,
      selectedPlayers,
      storageName
    );

    const getLocalStorage = getItemLocalStorage(storageName);
    // console.log("getLocalStorageeees", getLocalStorage.length);

    if (getLocalStorage.length <= 0) {
      favWrapper.classList.add("d-none");
    }

    RemoveRowAndUpdateLocalStorage(+row.dataset.id);
  }
});

// ------------------------------------------------------------
// set row to favorite table

function SetRowToFavorite(id) {
  // console.log($getAllPlayers);

  selectedPlayers.push(+id);

  setItemLocalStorage(storageName, selectedPlayers);

  CreateTabelRowFromLocalStorage();
}

// ------------------------------------------------------------
// create table row from locastorage

function CreateTabelRowFromLocalStorage() {
  const getLocalStorage = getItemLocalStorage(storageName);

  // console.log("aaaaaaaaa", storageName);

  const getAllPlayersArray = convertJSONToArray(HQ.Properties.getAllPlayers);

  selectedPlayers = [];

  // console.log("array", array);
  if (getLocalStorage) {
    selectedPlayers.push(...new Set(getLocalStorage));
  }

  tableFavorites.textContent = "";

  if (!getLocalStorage || getLocalStorage?.length <= 0) return;

  favWrapper.classList.remove("d-none");

  getAllPlayersArray.map((item) => {
    const {
      teetime,
      holesplayed,
      position,
      status,
      course_id,
      matchnumber,
      startingtee,
      currenthole,
    } = item;

    const global = {
      fav: true,
      teetime,
      position,
      status,
      course_id,
      matchnumber,
      holesplayed,
      startingtee,
      currenthole,
      players,
    };

    // check typeSite
    let players =
      HQ.Properties.typeSite === "scoring"
        ? { ...item, ...global }
        : Object.entries(item.players).map(([key, player]) => {
            return { ...player, ...global };
          });

    // SCORING
    if (HQ.Properties.typeSite === "scoring") {
      let {
        id,
        position,
        position_str,
        proam,
        fullname,
        country,
        rounds,
        totaltopar,
        course_id,
        totaltopar_str,
        strokes,
      } = players;

      let { par, parColorClass } = ColorAndPar(totaltopar, totaltopar_str);

      par = par !== null ? par : "";

      if (!getLocalStorage.includes(id)) return;

      const curentround =
        typeof HQ.Properties.currentRound === "undefined"
          ? ""
          : ThruColumn(players);

      let curentRoundRow = "";
      if (currentRoundExist) {
        curentRoundRow =
          +HQ.Properties.currentRound > 1 ? RoundsColumn(players) : "";
      } else {
        curentRoundRow = RoundsColumn(players);
      }

      const colorsMultiCourse = course_id ? GetColorFromCourse(+course_id) : "";

      const rowData = {
        id,
        posOrGroup: position_str ?? position,
        fullname,
        proam: proam === "am" ? "(A)" : "",
        country: country.toLowerCase(),
        parOrTee: `<span class="${parColorClass}">${par}</span>`,
        thruOrTime: curentRoundRow,
        thruColumn: curentround,
        courseColor: colorsMultiCourse,
      };

      tableFavorites.insertAdjacentHTML("beforeend", RowTemplate(rowData));

      SetActiveRow(id);
    }

    // DRAW
    if (HQ.Properties.typeSite === "draw") {
      players.map((player) => {
        if (!getLocalStorage.includes(player.id)) return;

        let {
          id,
          matchnumber,
          status,
          country,
          totaltopar,
          totaltopar_str,
          course_id,
          teetime,
          proam,
          startingtee,
          holesplayed,
          fullname,
        } = player;

        const { par, parColorClass } = ColorAndPar(totaltopar, totaltopar_str);

        // Show a * for all matches not starting from Tee 1
        const startingTee = +startingtee;

        let startingTeeStar = "";
        if (startingTee !== 1) {
          startingTeeStar = "*";
        }

        let timeTemplate;

        if (status == "PLAYING") {
          timeTemplate = `<span class="${parColorClass}">${par}</span> ${holesplayed}${startingTeeStar}`;
        } else if (status == "FINISHED") {
          timeTemplate = `<span class="${parColorClass}">${par}</span> F`;
        } else {
          timeTemplate = teetime?.slice(0, 5);
        }

        const colorsMultiCourse = course_id
          ? GetColorFromCourse(+course_id)
          : "";

        const rowData = {
          id,
          posOrGroup: matchnumber,
          fullname,
          proam: proam === "am" ? "(A)" : "",
          country: country.toLowerCase(),
          parOrTee: startingtee,
          thruOrTime: `<td class="text-center">${timeTemplate}</td>`,
          courseColor: colorsMultiCourse,
        };

        tableFavorites.insertAdjacentHTML("beforeend", RowTemplate(rowData));

        SetActiveRow(id);
      });
    }
  });
}

/**
 * Thru column in scroing site
 * @param {object} player
 */
function ThruColumn(player) {
  HQ.Properties.currentRound = +HQ.Properties.currentRound;
  let stat = "";
  if (typeof HQ.Properties.currentRound === "undefined") {
    stat = "";
  } else {
    let holesPlayed = null;
    let startingTeeStar = "";
    let startingTee = null;
    let teetime = null;

    // console.log("startingtee", player["rounds"][2]["startingtee"]);

    if (player["rounds"][HQ.Properties.currentRound]) {
      holesPlayed = player["rounds"][HQ.Properties.currentRound]["holesplayed"];
      // Show a * for all matches not starting from Tee 1
      startingTee = player["rounds"][HQ.Properties.currentRound]["startingtee"];

      if (startingTee !== 1) {
        startingTeeStar = "*";
      }

      teetime = player["rounds"][HQ.Properties.currentRound]["teetime"]?.slice(
        0,
        5
      );
    }

    // convert string to number
    // const statusNumber = Number(player["status"]);
    // console.log($startingTeeStar);

    if (Number(player["rounds"][HQ.Properties.currentRound]?.status) === 2) {
      stat = "F";
    } else if (
      Number(player["rounds"][HQ.Properties.currentRound]?.status) === 1
    ) {
      stat = `${teetime}${startingTeeStar}`;
    } else {
      const holesPlayerAndStartingTee = `${holesPlayed}${startingTeeStar}`;

      stat =
        holesPlayerAndStartingTee !== "null" ? holesPlayerAndStartingTee : "";
    }
  }

  return `<td class="text-center">${stat}</td>`;
}

// ------------------------------------------------------------
// click on favorites and remove row and remove class
// active-row from table players

tableFavorites.addEventListener("click", (e) => {
  // console.log(e);
  e.preventDefault();

  const target = e.target;

  if (target.classList.contains("icon-star")) {
    const row = target.closest("tr");

    selectedPlayers = selectedPlayers.filter(
      (id) => id !== Number(row.dataset.id)
    );

    row.remove();

    setItemLocalStorage(storageName, selectedPlayers);

    const rowFromFavorites = select(`[data-id="${row.dataset.id}"]`);
    rowFromFavorites?.classList.remove("active-row");

    RemoveRowAndUpdateLocalStorage(+row.dataset.id);
  }

  HideShowFavWrapper(favWrapper, countRowInTable(tableFavorites));
});
